import { useProjectFinancialSummary } from "@/hooks/useProjectFinancialSummary";
import FinancialSummary from "@/components/financial/FinancialSummary";
import FinancialSummarySkeleton from "@/components/financial/FinancialSummarySkeleton";
import type { ProjectFinancialSummary } from "@/generated/types";

const EMPTY_SUMMARY: ProjectFinancialSummary = {
  totalContractsValue: 0,
  totalPaid: 0,
  totalPending: 0,
  totalOverdue: 0,
  balance: 0,
  contractsCount: 0,
  installmentsCount: 0,
  paidInstallmentsCount: 0,
  pendingInstallmentsCount: 0,
  overdueInstallmentsCount: 0,
};

interface SummarySectionProps {
  projectId: string;
}

export default function SummarySection({ projectId }: SummarySectionProps) {
  const { summary, loading } = useProjectFinancialSummary(projectId);

  if (loading) return <FinancialSummarySkeleton />;

  return <FinancialSummary summary={summary ?? EMPTY_SUMMARY} />;
}
